<template>
  <div class="category-style-page">
    <van-nav-bar
        title="定制商品"
        left-text="返回"
        left-arrow
        @click-left="goback"

    />


    <van-list
        style="    padding-top: 10px;"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
    >
      <div @click="gotoNextStep(item)" class="series" :key="index" v-for="(item, index) in styles">


        <div v-if="designType=='LianTou'" class="info-img-liantou" :style="{backgroundImage:'url('+item.imageOne+')'}"></div>
        <img v-if="designType!='LianTou'" :src="item.imageOne"/>
        <div class="info-top">
          <div class="title">{{ item.name }}</div>
        </div>
      </div>
    </van-list>



  </div>
</template>

<script>
export default {
  name: "DingzhiDesign",
  components: {},
  data() {
    return {
      loading: false,
      finished: false,
      styles: [],
      data: [],
      page: 1,
      pageNum: 10,
      types: [],
      designId:this.$route.query.id,
      designType:this.$route.query.designType,
      activeitemname: '',
    };
  },

  mounted() {
    // this.getStyleData()
    this.getInfo();
  },

  methods: {
    getInfo() {
      let designId = this.designType == 'LianTou' ? null : this.designId
      this.$http.post("/public/customerDesignList", designId).then(res => {

        this.loading = false
        this.finished = true
        this.types = res.designGroupDTOS || []
        this.styles = this.types[0].designs || []

      });

    },
    goback() {
      history.go(-1)
    },
    gotoNextStep(item) {
      let designId = this.designType == 'LianTou' ? item.id : this.designId

      if(this.designType == 'LianTou') {
        this.$store.commit("SET_DESIGN_ID", designId || 0 ) // 保存款式id
      }
      this.$router.push('./dingzhidetail?designId=' +designId + '&customerDesignId=' + item.id + '&designType=' + this.designType);
    }
  },
};
</script>
<style scoped>
.product-info {
  display: flex;
  height: 150px;
  overflow: hidden;
  padding: 10px;
  font-size: 14px;
}

.product-info img {
  max-width: 100%;
  width: 150px;
  /* height: 200px; */
  /* overflow: hidden; */
  vertical-align: middle;
  margin-right: 10px;
  display: block;
}

.van-list {
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  margin-left: 10px;
}

.series {
  flex: 0 0 calc(50% - 10px);
  background: #fff;
  border-radius: 6px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.series img {
  max-width: 100%;
}


.info-img-liantou {
  min-height: 110px;
  background: no-repeat center center;
  background-size: 100%;
}

.info-img {
  background: no-repeat top center;
  background-size: cover;
}

.info-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 10px;
}

.series .tags {
  display: flex;

  padding: 0 10px 10px;
  font-size: 12px;
  align-items: center;
}

.series .tags .tag {
  color: #9B9B9B;
  margin-right: 10px;
}

.series .price-2 {
  font-size: 10px;
}

.price-color {
  color: var(--price-color);
  font-size: 14px;
  margin: 0 2px;
}

#app {
  padding-bottom: 0;
}
</style>
